import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2568">
      <div className="dark" data-id="element-2569">
        <Hero data-id="element-2570" />
      </div>
      <WhyUs data-id="element-2571" />
      <ByTheNumbers data-id="element-2572" />
      <Services data-id="element-2573" />
      <HowItWorks data-id="element-2574" />
      <FAQ data-id="element-2575" />
      <Reviews data-id="element-2576" />
      <CtaBanner data-id="element-2577" />
    </main>;
}